import { aanvragerStore } from '@/stores/aanvrager.js';
import { formStore } from '@/stores/form.js';
import { pakketStore } from '@/stores/pakket.js';
import { useDataFormat } from '@/composables/useDataFormat.js';

export function useDataLayer() {
  const pakket = pakketStore();
  const aanvrager = aanvragerStore();
  const form = formStore();
  const { capitalizeFirstLetter } = useDataFormat();
  
  // Flag to track first call
  let isFirstCall = true;

  const getTenant = () => {
    const tenant = form.tenant === 'alpina' ? 'Diks verzekeringen' : form.tenant;
    return capitalizeFirstLetter(tenant);
  };

  // The actual data layer push logic
  const pushToDataLayer = (event, routeIndex) => {
    window.dataLayer = window.dataLayer || [];
    const dataToSend = {
      event: event,
      checkout_step: routeIndex,
      ecommerce: {
        currency: 'EUR',
        value: pakket.getJaarPremie,
        transaction_id: form.sha,
        items: [
          {
            item_name: getTenant() + ' - ' + pakket.module,
            index: 0,
            item_brand: pakket.berekenstraat,
            item_category: getTenant() + ' - ' + pakket.module + ' ' + pakket.berekenstraat,
            price: pakket.getJaarPremie,
            quantity: '1',
          },
        ],
      },
    };

    if (event === 'purchase') {
      dataToSend.klant = {
        telefoonnummer: aanvrager.telefoonnummer,
        voorletters: aanvrager.voorletters,
        achternaam: aanvrager.achternaam,
        email: aanvrager.emailadres,
        straat: aanvrager.straat + ' ' + aanvrager.huisnummer,
        stad: aanvrager.woonplaats,
        postcode: aanvrager.postcode,
        land: 'NL',
      };
    }

    window.dataLayer.push(dataToSend);
    console.log('DataLayer pushed with tenant:', getTenant());
  };

  // The main function that either delays or runs immediately
  const addDataLayer = (event, routeIndex) => {
    // For the first call only, we'll delay to give tenant time to initialize
    if (isFirstCall) {
      isFirstCall = false;
      
      // Delay the first call
      setTimeout(() => {
        pushToDataLayer(event, routeIndex);
      }, 1000);
    } else {
      // For subsequent calls, run immediately
      pushToDataLayer(event, routeIndex);
    }
  };

  return { addDataLayer };
}
